import { computed, defineComponent, onMounted, PropType, watch } from 'vue';
import { useStore } from 'vuex';
import { useDateFormat } from '@/composables/dateFormat';
import { FiscalYear } from '@/store/fiscalYear/fiscalYear.model';
import { ProjectResultAction, ProjectResultGetter } from '@/store/projectResult/projectResult.module';
import { ReportResult } from '@/store/projectResult/projectResult.model';

export default defineComponent({
  name: 'ResultResponseComponent',
  props: {
    fiscalYear: {
      type: Object as PropType<FiscalYear>
    },
    mode: {
      type: String,
      default: 'PROVINCE',
    },
    targetId: {
      type: Number,
      default: 0,
    }
  },
  setup: (props) => {
    const dateFormat = useDateFormat();
    const store = useStore();
    const result = computed<ReportResult>(() => store.getters[ProjectResultGetter.RESULT]);

    onMounted(() => {
      if (props.fiscalYear && typeof props.fiscalYear === 'object') {
        store.dispatch(ProjectResultAction.GET_REPORT_RESULT, {
          fiscalYearId: props.fiscalYear.id,
          mode: props.mode,
          id: props.targetId,
        });
      }
    });

    watch(() => [props.fiscalYear, props.targetId], ([fiscalYear, targetId]) => {
      if (fiscalYear && typeof fiscalYear === 'object') {
        store.dispatch(ProjectResultAction.GET_REPORT_RESULT, {
          fiscalYearId: fiscalYear.id,
          mode: props.mode,
          id: targetId,
        });
      }
    });

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDateTime(date, 'short');

    return {
      result,
      thaiDate,
    };
  }
});
